import { Component, ElementRef, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { TransferService } from '../../_provider/transfer.service';
import { IonContent, NavParams, Platform, PopoverController } from '@ionic/angular';
import { DarkmodeService } from '../../_provider/darkmode.service';
import { TicketEditService } from '../../_provider/ticket-edit.service';
import { EditArt } from '../../_interfaces/EditArt';
import { TicketEmployee} from 'src/app/_provider/tickets/ticket.service';
import { WorkstepBase } from 'src/app/_interfaces/workstep';
import { ArrowKeysOptions } from 'src/app/_directives/ArrowKeysUseable.directive';
import { AuthService } from 'src/app/_provider/auth.service';
import { GeneralService } from 'src/app/_provider/general.service';

export interface PopoverListItem{
  id?: number,
  description: string,
  icon?: string,
  typeText?: string
  danger?: boolean
  success?: boolean
  stateColor?: string
  disabled?: boolean
  selected?: boolean
  event?: Event
}

@Component({
  selector: 'app-popover',
  templateUrl: './popover.page.html',
  styleUrls: ['./popover.page.scss'],
})
export class PopoverPage implements OnInit {

  public list: PopoverListItem[] = []

  public activeWorkstep: number 
  public type: string = ""
  private replaceArt: PopoverListItem
  @ViewChild(IonContent, {static: false}) contentRef: IonContent

  @ViewChild('itemList', {static: false}) listRef: any

  public arrowKeysOptions: ArrowKeysOptions = {
    selectedItem: -1,
    mouseOverItem: new EventEmitter<number>(null),
    mouseMove: new EventEmitter<boolean>(null),
    enterPressed: (index: number) =>{
      this.setClickedItem(this.list[index])
    }
  }

  constructor(
    private transfer: TransferService,
    private popoverCtrl: PopoverController,
    public darkmode: DarkmodeService,
    private navParams: NavParams,
    private authSrv: AuthService,
    private general: GeneralService,
    private ticketSrv: TicketEmployee.TicketService,
    private ticketEdtSrv: TicketEditService,
    private platform: Platform
  ) { }

  ngOnInit() {
    // this.list = this.transfer.getPopoverList()

    const type: 
    "custom" |
    "TicketArt" | 
    "Calculate" | 
    "Contact" | 
    "Priority" | 
    "Worksteps" | 
    "ContentArt" | 
    "ContentFrom" |
    "TicketFilterOne" |
    "TicketFilterTwo" |
    "contactPersonActions" |
    "AppointmentLocation" |
    "WorkstepSelect" |
    "TaskMenu"|
    "timeArt" |
    "addAsset" |
    "biometricFailed" |
    "ticketBaseMenu" |
    "customerHeaderMenu" |
    "employeeGroups" |
    "taskOptions" |
    "boardTicketSettings" |
    "CustomerLoginMailSend" |
    "wawiToGoOrCalculate" 
    = this.navParams.get("type")
    this.type = type
    this.replaceArt = this.navParams.get("replaceArt")


    switch(type){
      case "custom":
        //Übergeben mit Parameter list: EditArt[]
        break
      case "TicketArt": 
        this.list = this.ticketEdtSrv.ticketArts
        break
      case "Contact":
        this.list = this.ticketEdtSrv.contactArts.map(ca => ({icon: this.ticketSrv.getEditArtIconByIndex(ca.iconIndex), ...ca}))
        break
      case "ContentArt":
        this.list = [
          {id: 3, description: "Antwort", icon: "fa-reply"},
          {id: 4, description: "Interne Notiz", icon: "fa-message"},
          {id: 7, description: "Rechnungstext", icon: "fa-tag"},
        ]
        break
      case "Priority":
          this.list = [
            {id: 3, description: "Hoch", icon: "fa-arrow-up-right"},
            {id: 2, description: "Mittel", icon: "fa-arrow-right"},
            {id: 1, description: "Niedrig", icon: "fa-arrow-down-right"},
          ]
          break
      case "ContentFrom":
        this.list = this.ticketEdtSrv.contentFrom
        break
      case "Calculate": 
        this.list = this.ticketEdtSrv.toCalculateList
        break
      case "Worksteps":
        const workstepList: WorkstepBase[] = this.navParams.get("workstepList")
        if(workstepList) workstepList.forEach(wl => this.list.push({id: wl.id, description: wl.description ? wl.description : `Nr.${wl.number}/${wl.contactDescription}/${wl.employee?.firstName || ""}/${wl.employee.lastName || ""}`}))
        else{
          this.list = this.ticketEdtSrv.worksteps
          const activeWorkstep: number = this.navParams.get("activeWorkstep")
          if(activeWorkstep) this.activeWorkstep = activeWorkstep
        }
        break
      case "TicketFilterOne":
        this.list = [
          {id: 0, typeText: "my", description: "Meine Tickets", icon: "fa-user"},
          {id: 1, typeText: "all", description: "Alle Tickets", icon: "fa-user-group"}
        ]
        break
      case "TicketFilterTwo":
        this.list = [
          {id: 0, typeText: "all", description: "Alle", icon: "fa-puzzle"},
          {id: 1, typeText: "open", description: "Offen", icon: "fa-hammer"},
          {id: 2, typeText: "finish", description: "Fertig", icon: "fa-check"},
          {id: 3, typeText: "wait", description: "Warten", icon: "fa-hand"}
        ]
        break
      case "contactPersonActions":
        this.list = this.navParams.get("actions") as EditArt[]
        break
      case "AppointmentLocation":
        this.list = [
          {id: 0, description: "Außerhaus", icon: "fa-car"},
          {id: 1, description: "Inhaus", icon: "fa-house"}
        ]
        break
      case "WorkstepSelect":
        this.list = [
          {id: 1, description: "Neuer Arbeitsschritt", icon: "fa-plus"},
          {id: 2, description: "Arbeitsschritt-Bezeichnung ändern", icon: "fa-pen"},
          {id: 7, description: "Ticketname ändern", icon: "fa-pen"}
        ]
        this.list.push({id: 3, description: "Ticketbericht", icon: "fa-chart-mixed"})
        if(!this.platform.is("capacitor")) {
          this.list.push({id: 4, description: "Ticket-Link kopieren", icon: "fa-link"})
          if(!this.general.webConfig.isStandalone) this.list.push({id: 5, description: "In Desktop-Version öffnen", icon: "fa-desktop"})
          this.list.push({id: 6, description: "In neuem Tab öffnen", icon: "fa-open-new"})
        }
        break
      case "TaskMenu":
        this.list = [
          {id: 1, description: "Einträge", icon: "fa-message"},
          {id: 2, description: "Bezeichnung ändern", icon: "fa-pen"},
          {id: 3, description: "Zeit starten", icon: "fa-timer"},
          {id: 4, description: "Löschen", icon: "fa-trash", danger: true},
        ]
        break
      case "timeArt":
        this.list = [{ id: 0, description: "Ticketzeiten", icon: "fa-ticket"}]
        this.ticketSrv.tasks.map(t => this.list.push({id: t.id, description: t.description, icon: "fa-check"}))
        break;
      case "addAsset":
        this.list = [
          {id: 1, description: "Bild", icon: "fa-image"},
        ]
        if(this.general.webConfig.hasManagerConnection) this.list.unshift({id: 0, description: "Artikel", icon: "fa-box"})
        break
      case "biometricFailed":
        this.list = [
          {id: 1, description: "Erneut versuchen", icon: "fa-sign-out"},
          {id: 2, description: "Abmelden", icon: "fa-repeat"}
        ]
        break
      case "customerHeaderMenu": 
        this.list = [
          {id: 1, description: !this.darkmode.isDarkModeValue ? "Darkmode" : "Lightmode", icon: "fa-darkmode"},
          {id: 2, description: "Neu laden", icon: "fa-repeat"},
          {id: 3, description: "Abmelden", icon: "fa-sign-out"}
        ]
        break
      case "ticketBaseMenu":
        this.list = [
          {id: 1, description: "Anpinnen", icon: "fa-pin"},
          {id: 2, description: "Löschen", icon: "fa-trash", danger: true},
        ]
        if(!this.platform.is("capacitor")) this.list.push(
          {id: 3, description: "In neuem Tab öffnen", icon: "fa-open-new"}
        )
        break
      case "employeeGroups":
          this.list = this.ticketEdtSrv.employeeGroupes.map(g => ({id: g.id, description: g.description}))
          break
      case "taskOptions":
          this.list = [
            {id: 1, description: "Vorlage importieren", icon: "fa-import"}
          ]
          if(this.authSrv.getUser()?.role?.includes("access_settings"))
            this.list.push({id: 2, description: "Vorlage erstellen", icon: "fa-export"})
          break;
      case "boardTicketSettings":
        this.list = [
          {id: 1, description: "Zeit starten", icon: "fa-timer"},
          {id: 2, description: "Im neuem Tab öffnen", icon: "fa-open-new"},
          {id: 3, description: "Löschen", icon: "fa-trash", danger: true}
        ]
        break;
        case "wawiToGoOrCalculate": 
          this.list = [
            {id: 1, description: "WaWi-ToGo öffnen", icon: "wawitogo"},
            {id: 2, description: "Berechnen", icon: "fa-dollar-sign"}
          ]
          break;
        case "CustomerLoginMailSend":
          this.list = [
            {id: 1, description: "Aus"},
            {id: 2, description: "Immer nachfragen"},
            {id: 3, description: "Immer senden"}
          ]
        break;
      default:
        // this.list = [
        //   {id: 1, description: "Niedrig"},
        //   {id: 2, description: "Mittel"},
        //   {id: 3, description: "Hoch"}    
        // ]
        break
    }

    if(this.replaceArt) this.list[this.list.findIndex(l => l.id == this.replaceArt.id)] = this.replaceArt

    const removeItemList: number[] = this.navParams.get("removeItems")
    if(!removeItemList) return
    removeItemList.map((val: number)=>this.list.splice(this.list.findIndex((item: EditArt)=>item.id == val), 1))

  }

  ngAfterViewInit(){
    this.arrowKeysOptions.ionContent = this.contentRef
    setTimeout(() => {
      this.listRef.nativeElement.focus()
    }, 2000);
  }

  setClickedItem(item: PopoverListItem, event?: Event){
    if(item.disabled) return
    this.transfer.setPopoverSetSelectedItem(item)
    this.popoverCtrl.dismiss({item: {...item, event}})
  }
}
